import React, { useState, useEffect } from 'react';

interface TypewriterTextProps {
  text: string;
  speed?: number;
  onComplete?: () => void;
  onCharacterTyped?: () => void;
}

const TypewriterText: React.FC<TypewriterTextProps> = ({ text, speed = 30, onComplete, onCharacterTyped }) => {
  const [displayedText, setDisplayedText] = useState('');
  const [currentIndex, setCurrentIndex] = useState(0);

  useEffect(() => {
    if (currentIndex < text.length) {
      const timer = setTimeout(() => {
        setDisplayedText(prev => prev + text[currentIndex]);
        setCurrentIndex(prev => prev + 1);
        // Scroll every 3 characters or on line breaks for better performance
        if (onCharacterTyped && (currentIndex % 3 === 0 || text[currentIndex] === '\n')) {
          setTimeout(onCharacterTyped, 0);
        }
      }, speed);

      return () => clearTimeout(timer);
    } else if (onComplete) {
      onComplete();
      // Final scroll when typing is complete
      if (onCharacterTyped) {
        setTimeout(onCharacterTyped, 0);
      }
    }
  }, [currentIndex, text, speed, onComplete, onCharacterTyped]);

  useEffect(() => {
    // Reset when text changes
    setDisplayedText('');
    setCurrentIndex(0);
  }, [text]);

  return <>{displayedText}</>;
};

export default TypewriterText;